module.exports = __webpack_public_path__ + "static/AkkuratLightPro-Regular-f4cb268a0d180eb3cb6b6fff4d1fd3cd.woff";